<template>
	<div>
		<a-table  :columns="columns"  :data-source="meters" :pagination="false" rowKey="pId" bordered>
			<span slot="suppleModeSlot"  slot-scope="text, record">
				{{getSupplyMode(record.SuppleMode)}}
			</span>
			<span slot="meterSolidSlot" slot-scope="text, record">
				{{getSolidType(record.MeterSolid)}}
			</span>
			<span slot="isValveSlot" slot-scope="text, record">
				{{getValveType(record.IsValve)}}
			</span>
			<span slot="deductionStyleSlot" slot-scope="text, record">
				{{getDeductionStyle(record.DeductionStyle)}}
			</span>
			<span slot="timerSwitchSlot" slot-scope="text, record">
				{{getOpenType(record.TimerSwitch)}}
			</span>
			<span slot="isFaultSlot" slot-scope="text, record">
				{{record.is_fault == '1' ? '是':'否'}}
			</span>
			<span slot="innerAction" slot-scope="text, record">
				<a-button size="small" icon="code" type="link" @click="editMeter(record)">修改</a-button>
				<a-popconfirm title="确定要删除该条记录?" ok-text="确定" cancel-text="取消" placement="bottom" @confirm="deleteMeter(record)">
					<a-button size="small" icon="close-circle" type="link">删除</a-button>
				</a-popconfirm>
				<a-button size="small" icon="column-width" type="link" @click="showChangeMeter(record)">换表</a-button>
				<a-button size="small" icon="file-text" type="link" @click="changeMeterHistory(record)">换表历史</a-button>
				<a-button size="small" icon="interaction" type="link" @click="changeMeterFault(record)">{{record.is_fault=='1'?'设为正常':'设为异常'}}</a-button>
			    <!-- <a-button size="small" icon="home" type="link" @click="showProduceInfo(record)">生产信息</a-button> -->
			</span>
		</a-table>
		<div style="padding: 0.625rem;color: red;" v-show="this.showFlag">
			注：括号里的表地址/采集器地址是10进制表示形式
		</div>
	</div>
</template>

<script>
	export default {
		props:['theObj'],
		data(){
			const columns = [
				{
					title: '关联ID',
					dataIndex: 'APID',
					className:'v-cell',
				},
				{
					title: '集中器',
					dataIndex: 'GPRSAddr',
					className:'v-cell',
				},
				{
					title: '铅封号',
					dataIndex: 'qfh',
					className:'v-cell',
				},
				{
					title: '钢印号',
					dataIndex: 'SteelNum',
					className:'v-cell',
				},
				{
					title: '供水方式',
					dataIndex: 'SuppleMode',
					scopedSlots: { customRender: 'suppleModeSlot' },
					className:'v-cell',
				},
				{
					title: '采集器地址',
					dataIndex: 'CollectorAddr',
					className:'v-cell',
				},
				{
					title: '表地址',
					dataIndex: 'MeterAddr',
					className:'v-cell',
				},
				{
					title: '虚实表',
					dataIndex: 'MeterSolid',
					scopedSlots: { customRender: 'meterSolidSlot' },
					className:'v-cell',
				},
				{
					title: '表类型',
					dataIndex: 'MeterTypeName',
					className:'v-cell',
				},
				{
					title: '单价',
					dataIndex: 'PriceKindName',
					className:'v-cell',
				},
				{
					title: '阀门',
					dataIndex: 'IsValve',
					scopedSlots: { customRender: 'isValveSlot' },
					className:'v-cell',
				},
				{
					title: '有阀扣费方式',
					dataIndex: 'DeductionStyle',
					scopedSlots: { customRender: 'deductionStyleSlot' },
					className:'v-cell',
				},
				{
					title: '关阀余额',
					dataIndex: 'ValveOFFThre',
					className:'v-cell',
				},
				{
					title: '端口',
					dataIndex: 'port',
					className:'v-cell',
				},
				{
					title: '用量阀值',
					dataIndex: 'Overflow',
					className:'v-cell',
				},
				{
					title: '扣费读数',
					dataIndex: 'DeRead',
					className:'v-cell',
				},
				{
					title: '阶梯起始',
					dataIndex: 'destartread',
					className:'v-cell',
				},
				{
					title: '换表底数',
					dataIndex: 'changend',
					className:'v-cell',
				},
				{
					title: '异常状态',
					dataIndex: 'is_fault',
					scopedSlots: { customRender: 'isFaultSlot' },
					className:'v-cell',
				},
				{
					title: '操作',
					width:100,
					scopedSlots: { customRender: 'innerAction' },
					className:'v-cell',
				},	
			];
			return{
				columns,
				meters:[],
				showFlag:false,
			}
		},
		methods:{
			getSupplyMode:function({cellValue}){
				return this.Config.getValueByNameFromList(cellValue,this.Config.getSupplyModeList());
			},
			getSolidType:function(theV){
				return this.Config.getValueByNameFromList(theV,this.Config.getSolidList());
			},
			getValveType:function(theV){
				return this.Config.getValueByNameFromList(theV,this.Config.getHasList());
			},
			getOpenType:function(theV){
				return this.Config.getValueByNameFromList(theV,this.Config.getOpenList());
			},
			getDeductionStyle:function(theV){
				return this.Config.getValueByNameFromList(theV,this.Config.getDeductionStyleList());
			},
			queryMeters:function(){
				let url = this.Api.getLastUrl(this.Api.CUSTOMER_METERS_URL);
				let param = {theId:this.theObj.pId};
				this.Api.fetchPostWithForm(url,param).then((data)=>{
					let code = data.data.code;
					let result = data.data.result;
					let msg = data.data.message;
					if(code == this.Api.HTTP_OK_CODE){
						this.meters = result;
						for(var i =0;i<result.length;i++){
							let item = result[i];
							if(item.type == 11){
								this.showFlag = true;
								break;
							}
						}
					}else{
						this.$message.error(msg);
					}
				}).catch((error)=>{
					console.log(error);
				});
			},
			editMeter:function(record){
				this.$emit('editMeter',[record]);
			},
			deleteMeter:function(record){
				this.$emit('deleteMeter',[record]);
			},
			showChangeMeter:function(record){
				this.$emit('showChangeMeter',[record]);
			},
			changeMeterHistory:function(record){
				this.$emit('changeMeterHistory',[record]);
			},
			changeMeterFault:function(item){
				let url = this.Api.getLastUrl(this.Api.CUSTOMER_METER_CHANGE_FAULT_URL);
				let theFault = item.is_fault == '1'?'0':'1';
				let param = {meterId:item.PID,fault:theFault};
				this.Api.fetchPostWithForm(url,param).then((data)=>{
					this.changeSubmitFlag = false;
					let code = data.data.code;
					let msg = data.data.message;
					if(code == this.Api.HTTP_OK_CODE){
						this.$message.success('设置成功');
						this.queryMeters();
					}else{
						this.$message.error(msg);
					}
				}).catch((error)=>{
					console.log(error);
				});
			},
		},
		
		created() {
			this.queryMeters();
		}
	}
</script>

<style>
</style>
